module.exports = __webpack_public_path__ + "media/images/lp_v6_reserve_bg_1-3e107b1273e9231d6a42ee3dd7ea58de.webp";